exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/www/kh_indesso_web/src/app/components/company/companies-add-edit/companies-add-edit.component.less
// module id = ../../../../../src/app/components/company/companies-add-edit/companies-add-edit.component.less
// module chunks = 0